export default __webpack_public_path__ + "static/media/tab-profile-act.d4931e63.svg";